import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase'; // Import your Firebase db instance
import Navbar from '../components/home/Navbar'; // Adjust this import if necessary

const ViewComite = () => {
  const [pdfUrl, setPdfUrl] = useState(null);

  useEffect(() => {
    const fetchComiteData = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'comite'));
        if (querySnapshot.empty) {
          throw new Error('No data found in comite collection');
        }

        // Assuming there's only one document, get it directly
        const docData = querySnapshot.docs[0].data();
        setPdfUrl(docData.lien);
      } catch (error) {
        console.error("Error fetching comite data: ", error);
      }
    };

    fetchComiteData();
  }, []);

  const headingStyle = {
    fontSize: '2.5rem',
    color: '#ffffff', // White text color for contrast
    textAlign: 'center',
    marginBottom: '30px',
    fontFamily: 'Chalkboard, Comic Sans MS, cursive, sans-serif',
    backgroundColor: '#00674b',
    padding: '15px 20px', // Padding around the text
    borderRadius: '8px', // Rounded corners
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Subtle shadow for depth
    textShadow: '1px 1px 2px rgba(0, 0, 0, 0.2)', // Slight shadow for better readability
  };const pageStyle = {
    backgroundColor: '#f0f4f8', // Light grey-blue background
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  };
  
  const containerStyle = {
    padding: '20px',
    maxWidth: '1200px',
    width: '100%',
    margin: '20px',
    backgroundColor: '#ffffff', // White background for the content area
    borderRadius: '8px', // Rounded corners
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Subtle shadow for depth
  };
  
  return (
    <div style={pageStyle}>
      <Navbar />
      <div style={containerStyle}>
        <h2  style={headingStyle}>
         Comité
        </h2>
        <div style={{ textAlign: 'center' }}>
          {pdfUrl ? (
            <iframe
              src={pdfUrl}
              width="80%"
              height="1200px"
              frameBorder="0"
              title="PDF Viewer"
            >
              This browser does not support PDFs. Please download the PDF to view it: <a href={pdfUrl}>Download PDF</a>.
            </iframe>
          ) : (
            <p>Loading...</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewComite;
